import {prepareCustomerOfferSend} from "@project/sdk/sales";
import {PrepareCustomerOfferSendResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {customerOfferKeys} from "../../../customerOffer-keys";
import {assertCustomerOfferPreparedDocument} from "../../../customerOffer-read";

export function prepareCustomerOfferSendQueryOptions(id: string) {
  return queryOptions({
    ...queryPolicyDefaults.realtime,
    // Confirmation is explicitly requested, never silently refreshed or persisted.
    enabled: false,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnMount: false,
    queryKey: customerOfferKeys.prepareSend(id),
    queryFn: async ({signal}) => {
      const response = await prepareCustomerOfferSend(id, {signal});
      const parsed = PrepareCustomerOfferSendResponse.parse(response);
      assertCustomerOfferPreparedDocument(parsed, response);
      if (parsed.customerOfferId.toLowerCase() !== id.toLowerCase())
        throw new Error("Prepared document identity does not match requested Offer");
      return parsed;
    },
  });
}
